import { ref, watch } from "vue";

/*
 * https://stackoverflow.com/questions/63471824/vue-js-3-event-bus
 * */
export default class EventBus {
  constructor() {
    this.init();
  }
  init() {
    this.bus = ref(new Map());
  }
  $emit(event, arg?) {
    if (arg) {
      this.bus.value.set(event, {
        data: arg,
        ts: new Date().getTime().toString(),
      });
      return;
    }
    this.bus.value.set(event, {
      ts: new Date().getTime().toString(),
    });
  }
  $on(event, cb) {
    return watch(
      () => this.bus.value.get(event),
      (event) => {
        cb(event.data);
      },
    );
  }
}
